import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { CadenceType } from '~/monolith-api';

export type CreatePeriodicReviewScheduleResult = {
   prsid: number;
   title: string;
   cadence_type: CadenceType;
   grace: number;
   absolute_cadence_day: number;
   absolute_cadence_month: number;
   relative_cadence_span: number;
   userid: number;
   created_date: number;
   deleted: boolean | null;
   deleted_date: number | null;
};

export type CreatePeriodicReviewScheduleOptions = CommonRequestOptions & {
   cadence_type: CadenceType;
   grace: number;
   absolute_cadence_day: number;
   absolute_cadence_month: number;
   relative_cadence_span: number;
   title?: string;
};

export function createPeriodicReviewSchedule({
   cadence_type,
   grace,
   absolute_cadence_day,
   absolute_cadence_month,
   relative_cadence_span,
   title,
   ...common
}: CreatePeriodicReviewScheduleOptions): Promise<CreatePeriodicReviewScheduleResult[]> {
   return makeRequest('post', `periodic_review`, {
      ...common,
      body: {
         cadence_type,
         grace,
         absolute_cadence_day,
         absolute_cadence_month,
         relative_cadence_span,
         title,
      },
   });
}
